import Component from './Component';
import Hammer from 'hammerjs';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */
let mc;
let prevSlide = 0;
let initSlide = 0;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */







/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class Slider extends Component {

  decorator () {
    return {
      selector : '.js-slider',
      name : 'Slider',
    }
  }


  constructor(element) {
    super(element);

    // INITIAL CALLS
    this.cacheElements();

    // MOVE TO FIRST SLIDE BY DEFAULT
    this.moveSlide(0);

    this.bindControls();

    // BIND BULLETS
    this.bindBullets();

    // BIND TOUCH EVENTS
    this.bindTouchEvents();
  }

  cacheElements () {
    this.$el = document.querySelector(this.selector);
    this.$slides = this.$el.querySelector('.js-slider__slides');
    this.$items = Array.from(this.$slides.querySelectorAll('.js-slider__item'));
    this.$controls = this.$el.querySelector('.js-slider__controls');
    this.$bulletCont = this.$el.querySelector('.js-slider__bullets');
    this.$bullets = Array.from(this.$el.querySelectorAll('.js-slider__bullet'));
    this.$prevCtrl = this.$el.querySelector('.js-slider__prev');
    this.$nextCtrl = this.$el.querySelector('.js-slider__next');
    this.currentSlide = 0;
    this.animationTiming = 350;
  }


  bindBullets () {
    if (this.$bullets === null) { return; }

    this.$bullets.forEach((item, idx) => {
        const $bullet = item;

        $bullet.addEventListener('click', () => {
            this.moveSlide(idx);
        })
    })
  }


  bindControls () {
    if (this.$prevCtrl === null || this.$nextCtrl === null) { return; }

    this.$prevCtrl.addEventListener('click', () => { this.slidePrev() })
    this.$nextCtrl.addEventListener('click', () => { this.slideNext() })
  }


  bindTouchEvents () {
    mc = new Hammer(this.$el);

    mc.on('swipe', e => {
        if (e.direction == 2) {
            this.slideNext();
        } else if (e.direction == 4) {
            this.slidePrev();
        }
    })
  }


  moveSlide (curr) {
    prevSlide = this.currentSlide;

    this.currentSlide = curr;

    let _translate = this.currentSlide * -100;

    // this.$slides.style.transform = `translateX(${_translate}%)`;
    this.$slides.setAttribute('style', `transform: translateX(${_translate}%); -webkit-transform: translateX(${_translate}%)`)

    this.setBulletStates(this.currentSlide);

    this.setSlideStates(this.currentSlide);
  }


  // SET BULLET STATES
  setBulletStates (curr) {
    this.$bullets.forEach(item => item.classList.remove('is-active'))
    this.$bullets[curr].classList.add('is-active');
  }


  // SET SLIDE STATES
  setSlideStates (curr) {
    this.$items.forEach(item => item.classList.remove('is-active', 'is-loaded', 'is-hidden'))
    this.$items[curr].classList.add('is-active');
    this.$items[prevSlide].classList.add('is-hidden')
    setTimeout(() => {
        this.$items[curr].classList.add('is-loaded');
    }, this.animationTiming)
  }


  slidePrev () {
    initSlide = (this.currentSlide > 0) ? this.currentSlide - 1 : this.currentSlide;
    this.moveSlide(initSlide);
  }


  slideNext () {
    initSlide = (this.currentSlide < this.$items.length - 1) ? this.currentSlide + 1 : this.currentSlide;
    this.moveSlide(initSlide)
  }


}
